export const formateQuesType = (id, questionType) => {
  switch (id) {
    case 1:
      return '单项选择题'
    case 2:
      return '多项选择题'
    case 6:
      return '判断题'
    case 10:
      return 'Python编程操作题'
    case 11:
      return questionType === 5 ? '闯关题' : '图形化编程操作题'
    case 12:
      return 'C++编程操作题'
    case 20:
      return '填空题'
    default:
      return ''
  }
}

export const mediaInfo = {
  a: {
    type: 'a',
    typeName: '浏览器不支持',
    cameraTip: '您的浏览器不支持获取摄像头',
    audioTip: '您的浏览器不支持获取音频'
  },
  b: {
    type: 'b',
    typeName: '获取权限失败',
    cameraTip: '检测到当前没有启用摄像头的权限',
    audioTip: '检测到当前没有启用录音的权限'
  },
  c: {
    type: 'c',
    typeName: '设备不支持',
    cameraTip: '检测到浏览器不支持的硬件设备',
    audioTip: '检测到浏览器不支持的硬件设备'
  },
  d: {
    type: 'd',
    typeName: '无设备',
    cameraTip: '检测没有发现指定的硬件设备',
    audioTip: '检测没有发现指定的硬件设备'
  },
  e: {
    type: 'e',
    typeName: '设备无声音',
    cameraTip: '',
    audioTip: '检测到设备没有录音输入'
  },
  f: {
    type: 'f',
    typeName: '设备异常',
    cameraTip: '检测到设备出现异常中止了的视频',
    audioTip: '检测到设备出现异常中止了录音'
  },
  g: {
    type: 'g',
    typeName: '其他原因',
    cameraTip: '请先接入摄像头',
    audioTip: '请先接入麦克风'
  },
  h: {
    type: 'h',
    typeName: '人工判定问题',
    cameraTip: '摄像头看不到图像',
    audioTip: '麦克风录制声音听不到'
  },
  i: {
    type: 'i',
    typeName: '正常'
  }
}

export const getNatialPath = (env) => {
  let path = ''
  switch (env) {
    case 'test':
      path = '0520'
      break
    case 'staging':
      path = '0523'
      break
    case 'production':
      path = 'znsjhxth2024'
      break
  }
  return path
}
